#@import Booking.Views.PickerCollection
#@import Booking.Views.Option
#@export Booking.Views.Options

class Booking.Views.Options extends Booking.Views.PickerCollection

  tagName: 'ul'

  childView: Booking.Views.Option
